module.exports = __webpack_public_path__ + "img/VaccinCovid19.9a99cffd.svg";